module.exports = __webpack_public_path__ + "static/media/object.2767d079.gif";